"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Avatar_1 = __importDefault(require("../Avatar/Avatar"));
const styled_1 = __importDefault(require("../utils/styled"));
const Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
const MAX_MORE = 10;
const Container = styled_1.default("div")({
    display: "flex",
    marginLeft: 12,
});
const AvatarContainer = styled_1.default.div `
  position: relative;
  margin-left: -12px;

  [data-avatar] {
    display: none;
  }
  :hover > [data-avatar] {
    display: block;
  }
`;
const AvatarGroup = (_a) => {
    var { avatars, size, onMoreClick } = _a, props = __rest(_a, ["avatars", "size", "onMoreClick"]);
    // Should at least display one avatar
    const maxToDisplay = Math.max(props.maximumToDisplay || 1, 1);
    const overflow = avatars.length - maxToDisplay + 1;
    const mustSlice = overflow > 0;
    const displayAvatars = mustSlice ? avatars.slice(0, maxToDisplay - 1) : avatars;
    const moreAvatars = mustSlice ? avatars.slice(maxToDisplay - 1, maxToDisplay - 1 + MAX_MORE) : null;
    return (React.createElement(Container, Object.assign({}, props),
        displayAvatars.map((avatar, i) => (React.createElement(AvatarContainer, { key: i },
            React.createElement(Tooltip_1.default, { "data-avatar": true, position: "top" }, avatar.name),
            React.createElement(Avatar_1.default, Object.assign({ addBorder: true, size: size }, avatar))))),
        moreAvatars && (React.createElement(AvatarContainer, { key: "more" },
            React.createElement(Tooltip_1.default, { "data-avatar": true, position: "top" },
                moreAvatars.map((avatar, i) => (React.createElement(React.Fragment, { key: i },
                    avatar.name,
                    React.createElement("br", null)))),
                overflow - MAX_MORE > 0 && "..."),
            React.createElement(Avatar_1.default, { addBorder: true, size: size, onClick: onMoreClick, name: "more", assignColor: false },
                "+",
                overflow)))));
};
AvatarGroup.defaultProps = {
    maximumToDisplay: 4,
};
exports.default = AvatarGroup;
//# sourceMappingURL=AvatarGroup.js.map